<template>
    <aside class="graph-details left">
        <div class="analysis-header">
            <h2>{{translate("parameters")}}</h2>
        </div>
        <div class="parametres-container details">
            <div class="elements-container">
                <div class="element">
                    <h3 class="title" v-html="">{{translate('keep_original_characteristic')}} <span>({{oryginalCharacteristic}} Hz)</span>
                    </h3>
                    <div class="option-container radio_type">
                        <div v-for="(element, element_id) in oryginalCharacteristicOptions"
                             class="radio-btn"
                             :class="{checked : element.active}">
                            <input type="radio"
                                   :id="'oryginalCharacteristic' + element.value"
                                   :value="element.value"
                                   :checked="element.active"
                                   @change="changeOryginalCharacteristicValue(element_id)"
                                   hidden>
                            <label :for="'oryginalCharacteristic' + element.value"
                                   v-html="translate((element.displayValue ? element.displayValue : element.value), false)"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="details-container">
            <div class="params-list" v-for="(param, param_id) in this.$store.state.detailsParams"
                 v-if="param.active && !isParamDisabled(param_id)"
                 v-bind:data-timeUpdate="updateTime">
                <div class="analysis-detail-title" v-html="translate(param.code)">
                    <div class="option-container">
                        <div class="value_with_select-container">
                            <div class="custom-select">
                                <div class="selected_item"
                                     v-for="(element2, element_id2) in param.units"
                                     v-if="element2.active">
                                <span class="value"
                                      v-html="translate((element2.displayValue ? element2.displayValue : element2.value), false)"/>
                                    <span class="icon-bottom_arrow"/>
                                </div>
                                <div class="items-container">
                                    <div class="item"
                                         v-for="(element2, element_id2) in param.units"
                                         :id="'_id_' + '_' + element_id2"
                                         @click="changeSelectedInParamsTable(element2, param.unitType)"
                                         v-html="translate((element2.displayValue ? element2.displayValue : element2.value), false)"
                                    >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="analysis-detail-params" v-if="!element.editable && !element.hidden"
                     v-for="(element, element_id) in param.lines">
                    <div class="col-one-desc tooltip" v-bind:style="{color: element.color}">
                        {{withoutValue(element.value)}}
                        <span class="tooltip-text" v-html="translate(element.title)"/>
                    </div>
                    <div class="col-two-desc tooltip" v-bind:style="{color: element.color}"
                         v-if="showOryginalCharacteristicks() && element_id != '_mouse' && element_id != '_static'">
                        {{withoutValue(element.value_hz)}}
                        <span class="tooltip-text" v-html="translate(element.title)"/>
                    </div>
                </div>
                <div class="option-container" v-if="element.editable && !element.hidden"
                     v-for="(element, element_id) in param.lines">
                    <div class="value_with_select-container">
                        <input type="text" pattern="\d*" maxlength="10" v-model.lazy="element.value"
                               @change="changeValue(element, $event.target.value)"
                               v-bind:style="{color: element.color}">
                        <div class="custom-select">
                            <div class="selected_item"
                                 v-for="(element2, element_id2) in element.elements"
                                 v-if="element2.active">
                                <span class="value"
                                      v-html="translate((element2.displayValue ? element2.displayValue : element2.value), false)"/>
                                <span class="icon-bottom_arrow"/>
                            </div>
                            <div class="items-container">
                                <div class="item"
                                     v-for="(element2, element_id2) in element.elements"
                                     :id="element_id + '_' + element_id2"
                                     @click="changeSelectedInParamsTable(element2, element.unitType)"
                                     v-html="translate((element2.displayValue ? element2.displayValue : element2.value), false)"
                                >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </aside>
</template>

<script>
    export default {
        name: "GraphsAnalysisAside",
        data() {
            return {
                oryginalCharacteristic: 0,
                oryginalCharacteristicOptions: {
                    yes: {
                        value: 'yes',
                        active: true,
                        default: true,
                    },

                    no: {
                        value: 'no',
                        active: false
                    }
                },
                msgTooltip: "Przykladowy tekst",
                lines: [
                    {name: "AirDensity", unitType: "air_density", code: "air_density", static: true}, // NVS-149
                    {name: "Temperature", unitType: "temperature", code: "temperature", static: true}, // NVS-149
                    {name: "Frequency", unitType: "frequency", code: "frequency", static: true},
                    {name: "TotalPressure", unitType: "pressure", code: "total_pressure"},
                    {name: "DynamicPressure", unitType: "pressure", code: "dynamic_pressure"},
                    {name: "TotalEfficiency", unitType: "efficiency", code: "total_efficiency"},
                    {name: "PowerOnShaft", unitType: "power", code: "power_on_shaft"},
                    {name: "PowerOnShaftWithMaterial", unitType: "power", code: "power_on_shaft_with_material"},
                    {name: "Noise", unitType: "noise", code: "noise"},
                    {name: "StaticPressure", unitType: "pressure", code: "static_pressure"},
                    {name: "StaticPressureIncrease", unitType: "pressure", code: "static_pressure_increase"},
                    {name: "StaticEfficiency", unitType: "efficiency", code: "static_efficiency"},
                    {name: "Amperage", unitType: "current", code: "amperage_v1"},
                    {name: "AmperageV2", unitType: "current", code: "amperage_v2"},
                    {name: "ElectricalPower", unitType: "power", code: "electrical_power"},
                ],
                details2: {
                    performance: {
                        units: {
                            0: {
                                unit: "m3/h",
                                active: true
                            },

                            1: {
                                unit: "m3/s",
                                active: false
                            }
                        },
                        title: "Wydajność",
                        lines: {
                            aa: {
                                editable: false,
                                value: 151004,
                                value_hz: 543,
                                elements: {
                                    0: {
                                        unit: "m3/h",
                                        active: true
                                    },

                                    1: {
                                        unit: "m3/s",
                                        active: false
                                    }
                                }
                            },
                            a1a: {
                                editable: false,
                                value: 151005,
                                value_hz: 543,
                                elements: {
                                    0: {
                                        unit: "m3/h",
                                        active: true
                                    },

                                    1: {
                                        unit: "m3/s",
                                        active: false
                                    }
                                }
                            },
                            bb: {
                                editable: true,
                                value: 151006,
                                value_hz: 543,
                                elements: {
                                    0: {
                                        unit: "m3/h",
                                        active: true
                                    },

                                    1: {
                                        unit: "m3/s",
                                        active: false
                                    }
                                }
                            },
                            bb1: {
                                editable: true,
                                value: 151007,
                                value_hz: 543,
                                elements: {
                                    0: {
                                        unit: "m3/h",
                                        active: true
                                    },

                                    1: {
                                        unit: "m3/s",
                                        active: false
                                    }
                                }
                            },
                        }
                    },

                }

            }
        },
        computed: {
            details() {
                return this.$store.state.detailsParams;
            },

            updateTime() {
                return this.$store.state.detailsParamsUpdateTime;
            },

            showOryginalCharacteristic() {
                return this.$store.state.detailsShowOryginalFrequency;
            }

        },
        watch: {
            details() {
                this.details2 = this.$store.state.detailsParams;
            },
            updateTime() {
                return this.$store.state.detailsParamsUpdateTime;
            }
        },
        methods: {

            isParamDisabled(paramKey) {
                let disabled = false;

                if (paramKey === 'PowerOnShaftWithMaterial') {
                    let activeFan = this.$store.state.activeFun;
                    if (activeFan.params.hasOwnProperty('power_on_shaft_with_material')) {
                        disabled = activeFan.params.power_on_shaft_with_material === activeFan.params.power_on_shaft;
                    } else {
                        disabled = true;
                    }
                }

                return disabled;
            },

            withoutValue(value) {
                if (value == "nieobliczalne" || value == "+nieskończoność" || value == "-nieskończoność") {
                    return "-";
                } else {
                    return value;
                }
            },

            changeValue(element, value) {
                if (value === '' || null) {
                    return;
                }

                element.onchange(value);
            },
            changeOryginalCharacteristicValue(element_id) {
                this.oryginalCharacteristicOptions['yes'].active = false;
                this.oryginalCharacteristicOptions['no'].active = false;
                this.oryginalCharacteristicOptions[element_id].active = true;

                if (element_id == 'yes')
                    this.$store.state.detailsShowOryginalFrequency = true;
                else
                    this.$store.state.detailsShowOryginalFrequency = false;

            },
            showOryginalCharacteristicks() {
                return this.$store.state.detailsShowOryginalFrequency;
            },
            toggleExpandOfCustomSelect(e) {

                let target = e.target;

                document.querySelectorAll('.custom-select').forEach((select) => {

                    select.classList.remove("expanded");
                });

                while (target instanceof Element) {

                    if (target.classList.contains('selected_item')) {

                        target.parentElement.classList.toggle("expanded");
                        return;

                    } else if (
                        target.classList.contains('value') ||
                        target.classList.contains('icon-bottom_arrow')) {

                        target.parentElement.parentElement.classList.toggle("expanded");
                        return;

                    } else if (target.classList.contains('items-container')) {

                        target.parentElement.classList.remove("expanded");
                        return;

                    } else if (target.classList.contains('item')) {

                        target.parentElement.parentElement.classList.remove("expanded");
                        return;

                    } else {
                        return;
                    }
                }
            },

            translate(code, displayErrors = true) {
                let arg = {
                    type: 'translate',
                    code: code,
                    displayErrors: displayErrors,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;

            },

            selectElementOfOptionInParam() {

                this.$store.commit({
                    type: 'changeSelectedUnitInValueUnitMap',
                });
            },
            changeSelectedInParamsTable(selected, param_id) {
                if (selected && selected.unit) {
                    this.$store.commit({
                        type: 'changeSelectedUnitInValueUnitMap',
                        param_id: param_id,
                        unitDescription: selected.value
                    });
                }
            },
            getActiveFunVoltages() {
                if (this.$store.state.activeFun && this.$store.state.activeFun.data && this.$store.state.activeFun.data.network_frequency && this.$store.state.activeFun.engine) {
                    let frequency = this.$fanObjParamsManager.GetSelectedElementOfOption(this.$store.state.fourthStepParametersSelected.network_frequency.options[0].elements);

                    let voltage = this.$store.state.activeFun.engine['voltage_' + frequency + '_hz'];

                    if (voltage) {
                        let voltages = voltage.split("/");

                        return voltages;
                    }
                }

                return [];
            }
        },

        mounted() {
            document.addEventListener("click", this.toggleExpandOfCustomSelect);
            this.details2 = this.$store.state.detailsParams;

            this.oryginalCharacteristicOptions['yes'].active = false;
            this.oryginalCharacteristicOptions['no'].active = false;

            if (this.showOryginalCharacteristic)
                this.oryginalCharacteristicOptions['yes'].active = true;
            else
                this.oryginalCharacteristicOptions['no'].active = true;
        },

        beforeDestroy() {
            document.removeEventListener("click", this.toggleExpandOfCustomSelect);
        },
        beforeMount() {
            this.oryginalCharacteristic = this.$store.state.activeFun.params.work_frequency;

            // if (!this.$store.state.detailsParams["Performance"] || !this.$store.state.detailsParams["Performance"].lines) {
            this.$store.state.detailsParams["Performance"] = {
                title: "Performance",
                code: "performance",
                unitType: "performance",
                units: [],
                active: true,
                lines: {
                    _mouse: {
                        hidden: false,
                        editable: true,
                        color: "FFFFFF",
                        title: "-",
                        value: 0,
                        value_hz: 0,
                        unitType: "performance",
                        elements: [],
                        onchange: () => {
                        },
                    },
                }
            };

            Object.assign(this.$store.state.detailsParams["Performance"].units, this.$store.state.ValueUnitMap["performance"].units);
            //         }

            for (let line of this.lines) {

                if (line.static) {
                    this.$store.state.detailsParams[line.name] = {
                        title: line.name,
                        code: line.code,
                        unitType: line.unitType,
                        units: [],
                        active: true,
                        lines: {
                            _static: {
                                hidden: false,
                                editable: true,
                                color: "black",
                                title: line.code,
                                value: 0,
                                value_hz: 0,
                                unitType: line.unitType,
                                elements: [],
                                onchange: () => {
                                },
                            }
                        },
                    }


                    continue;
                }

                for (let i = 0; i < 20; i++) {
                    this.$store.state.detailsParams["Performance"].lines[line.name + i] = {
                        hidden: true,
                        editable: false,
                        color: "FFFFFF",
                        title: "-",
                        value: 0,
                        value_hz: 0,
                        elements: {
                            0: {
                                unit: "m3/h",
                                active: true
                            },

                            1: {
                                unit: "m3/s",
                                active: false
                            }
                        },
                    }
                }

                // if (!this.$store.state.detailsParams[line.name] || !this.$store.state.detailsParams[line.name].lines) {
                this.$store.state.detailsParams[line.name] = {
                    title: line.name,
                    code: line.code,
                    unitType: line.unitType,
                    units: [],
                    active: true,
                    lines: {
                        _mouse: {
                            hidden: false,
                            editable: true,
                            color: "FFFFFF",
                            title: "-",
                            value: 0,
                            value_hz: 0,
                            unitType: line.unitType,
                            elements: [],
                            onchange: () => {
                            },
                        }
                    },
                }

                if (line.name == "AmperageV2") {
                    let voltages = this.getActiveFunVoltages();

                    if (!voltages[1])
                        this.$store.state.detailsParams[line.name].active = false;
                }

                Object.assign(this.$store.state.detailsParams[line.name].units, this.$store.state.ValueUnitMap[line.unitType].units);
                // }

                for (let j = 0; j < 10; j++) {
                    this.$store.state.detailsParams[line.name].lines[line.name + j] = {
                        hidden: true,
                        editable: true,
                        color: "FFFFFF",
                        title: "-",
                        value: 0,
                        value_hz: 0,
                        unitType: line.unitType,
                        elements: [],
                        onchange: () => {
                        },
                    }

                    Object.assign(this.$store.state.detailsParams[line.name].lines[line.name + j].elements, this.$store.state.ValueUnitMap[line.unitType].units);

                    this.$store.state.detailsParams[line.name].lines["Performance" + j] = {
                        hidden: true,
                        editable: false,
                        color: "FFFFFF",
                        title: "-",
                        value: 0,
                        value_hz: 0,
                        unitType: "performance",
                        elements: [],
                        onchange: () => {
                        },
                    }


                    Object.assign(this.$store.state.detailsParams[line.name].lines["Performance" + j].elements, this.$store.state.ValueUnitMap["performance"].units);
                }


            }

            for (let k = 0; k < 10; k++) {
                this.$store.state.detailsParams["Performance"].lines["Performance" + k] = {
                    hidden: true,
                    editable: true,
                    color: "FFFFFF",
                    title: "-",
                    value: 0,
                    value_hz: 0,
                    unitType: "performance",
                    elements: [],
                    onchange: () => {
                    },
                }


                Object.assign(this.$store.state.detailsParams["Performance"].lines["Performance" + k].elements, this.$store.state.ValueUnitMap["performance"].units);

            }

        }
    }
</script>

<style scoped>

</style>